module.exports = __webpack_public_path__ + "img/img7.3ba4c326.jpg";